import { Component, OnInit } from '@angular/core';
import { Field } from '../../field';
import { LayoutService } from '../../layout.service';
import * as accounting from 'accounting';
import * as g from 'src/app/globals';


@Component({
  selector: 'app-input-rate',
  templateUrl: './input-rate.component.html',
  styleUrls: ['./input-rate.component.scss']
})
export class InputRateComponent extends Field {

  constructor(public layoutService: LayoutService) {
    super(layoutService);
  }

  formatterRate(value: number): string {
    if (value === null || isNaN(value)) {
      value = 0;
    }

    return accounting.formatNumber(
      value,
      g.companyConfiguration.RateDecimal,
      g.companyConfiguration.ThousandSep,
      g.companyConfiguration.DecimalSep
    );
  }

}
